import styled from "styled-components";

export const ContainerWrapper = styled.div`
  width: 90%;
  max-width: 78.75rem;
  margin: 0 auto;
`;
